var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowButton = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7621 0.233059C11.5969 0.0668194 11.3973 0 11.1646 0H3.07459C2.59429 0 2.16998 0.341812 2.16998 0.822115V1.56012C2.16998 2.04042 2.59429 2.48862 3.07459 2.48862H7.83171L0.272403 10.0192C0.108528 10.1832 0.0181908 10.3875 0.0180664 10.6208C0.0180664 10.8541 0.108528 11.0655 0.272403 11.2295L0.794267 11.7475C0.958018 11.9115 1.17677 12 1.41008 12C1.64338 12 1.83837 11.9089 2.00224 11.7449L9.5114 4.21149V8.91262C9.5114 9.39305 9.94953 9.83005 10.4297 9.83005H11.168C11.648 9.83005 12.0001 9.39305 12.0001 8.91262V0.824977C12 0.59254 11.9279 0.397806 11.7621 0.233059Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowButton);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowButton.e20d4de28208bb34c54644c2746075e9.svg";